// extracted by mini-css-extract-plugin
export default {"container":"AddNewPerson-module__container___ybV8q","hasNoPeople":"AddNewPerson-module__hasNoPeople___l4xd0"};